import { getBasicLogInfo } from './utils';

const applicationChangeFromLotusNotesLogTransformer = origin => ({
  ...getBasicLogInfo(origin),
  operator: 'Lotus Notes',
  content: 'Application or loan details updated',
});

export default applicationChangeFromLotusNotesLogTransformer;
